import api from "@/api"

const state = {
  merchantOrders: [],
  invoices: [],
  orders: [],
  generatedInvoice: {}
}

const actions = {
  notif({ commit }, { payloads }) {
    return new Promise((resolve, reject) => {
      api.notification.notif(payloads).then(
        (response) => {
          resolve(response)
        },
        (error) => {
          reject(error)
        }
      )
    })
  }
}

const mutations = {
  setMerchantOrders(state, value) {
    state.merchantOrders = value
  },
  setInvoices(state, value) {
    state.invoices = value
  },
  setOrders(state, value) {
    state.orders = value
  },
  setGeneratedInvoice(state, value) {
    state.generatedInvoices = value
  }
}

const getters = {
  merchantOrders: state => state.merchantOrders,
  invoices: state => state.invoices,
  orders: state => state.orders,
  generatedInvoice: state => state.generatedInvoice
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
